import { Component, Input } from '@angular/core';

import { TeaserCard } from '../../../models/teaser-card';

@Component({
    selector: 'a[appTeaserCard]',
    templateUrl: './teaser-card.component.html',
    styleUrls: ['./teaser-card.component.scss'],
    standalone: false,
})
export class TeaserCardComponent {
    @Input()
    public teaserCard: TeaserCard;
}
